import { FC } from 'react';
import InfoIcon from '@/assets/info.svg';
import SuccessIcon from '@/assets/success-check.svg';
import WarningIcon from '@/assets/warning.svg';
import { cx } from '@/utils/cx';

export type InfoBarProps = {
  className?: string;
  text: string;
  variant?: 'info' | 'success' | 'error';
};

export const InfoBar: FC<InfoBarProps> = ({
  className,
  text,
  variant = 'info',
}) => (
  <div
    {...(variant === 'error' ? { role: 'alert' } : {})}
    className={cx(
      'flex w-full flex-row items-center gap-3 rounded-xl bg-blue-50 p-4 text-blue-400',
      variant === 'success' && 'bg-green-50 text-green-400',
      variant === 'error' && 'bg-warningTint text-warning',
      className,
    )}
  >
    {variant === 'info' && <InfoIcon />}
    {variant === 'success' && <SuccessIcon />}
    {variant === 'error' && <WarningIcon />}
    <div
      className={cx(
        'text-sm font-normal text-blue-700',
        variant === 'success' && 'text-green-800',
        variant === 'error' && 'text-warningShade',
      )}
    >
      {text}
    </div>
  </div>
);
